/** Kannada: Find as a conversation. */
export const need = {
    "need.start": "ನಿಮಗೆ ಯಾವ ಕೆಲಸ ಆಗಬೇಕು? ನಿಮ್ಮದೇ ಮಾತಿನಲ್ಲಿ ಹೇಳಿ.",
    "need.ask.trade": "ನಿಮಗೆ ಯಾವ ರೀತಿಯ ಕೆಲಸಗಾರರು ಬೇಕು?",
    "need.again": "ಕ್ಷಮಿಸಿ, ನನಗೆ ಅರ್ಥವಾಗಲಿಲ್ಲ.",
    "need.ask.area": "ಕೆಲಸ ಯಾವ ಏರಿಯಾದಲ್ಲಿದೆ?",
    "need.ask.when": "ಯಾರಾದರೂ ಯಾವಾಗ ಬರಬೇಕು? ಸಮಯವನ್ನೂ ಹೇಳಬಹುದು, ಉದಾಹರಣೆಗೆ ನಾಳೆ ಬೆಳಿಗ್ಗೆ 10 ಗಂಟೆಗೆ.",
    "need.ask.hour": "ಅವರು ಯಾವ ಸಮಯಕ್ಕೆ ಬರಬೇಕು?",
    "when.hour": "{time}",
    "when.any_time": "ಯಾವ ಸಮಯವಾದರೂ",
    "hour.morning": "ಬೆಳಿಗ್ಗೆ {h} ಗಂಟೆ",
    "hour.afternoon": "ಮಧ್ಯಾಹ್ನ {h} ಗಂಟೆ",
    "hour.evening": "ಸಂಜೆ {h} ಗಂಟೆ",
    "need.ask.budget": "ನೀವು ಗರಿಷ್ಠ ಎಷ್ಟು ಕೊಡುತ್ತೀರಿ? ಇದು ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ; ಕೆಲಸಗಾರರಿಗೆ ಕಾಣುವುದಿಲ್ಲ.",
    "need.band_month": "{city}ನಲ್ಲಿ ಜನರು ಸಾಮಾನ್ಯವಾಗಿ ಇದಕ್ಕೆ ತಿಂಗಳಿಗೆ {low} ರಿಂದ {high} ಕೊಡುತ್ತಾರೆ.",
    "need.band_visit": "{city}ನಲ್ಲಿ ಜನರು ಸಾಮಾನ್ಯವಾಗಿ ಇದಕ್ಕೆ ಒಂದು ಸಲಕ್ಕೆ {low} ರಿಂದ {high} ಕೊಡುತ್ತಾರೆ.",
    "need.again_budget": "ರೂಪಾಯಿಯಲ್ಲಿ ಮೊತ್ತ ಹೇಳಿ, ಉದಾಹರಣೆಗೆ ಏಳುನೂರು.",
    "need.got_budget": "ಗರಿಷ್ಠ {price}, ಬರೆದುಕೊಂಡೆ.",
    "need.err_long": "ಇದು ಉದ್ದವಾಯಿತು. ಕಡಿಮೆ ಪದಗಳಲ್ಲಿ ಹೇಳಿ.",
    "need.summary": "{trade}, ಏರಿಯಾ {area}. ಯಾವಾಗ: {when}.",
    "need.summary_time": "ಸಮಯ: {time}.",
    "need.summary_words": 'ಕೆಲಸಗಾರರು ಇದನ್ನು ಓದುತ್ತಾರೆ: "{words}"',
    "need.summary_detail": "{question} {answer}",
    "need.summary_budget": "ನೀವು ಗರಿಷ್ಠ {budget} ಕೊಡುತ್ತೀರಿ. ಇದು ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ.",
    "need.confirm": "ಯಾರನ್ನಾದರೂ ಹುಡುಕಲೇ?",
    "need.what_change": "ಏನು ಬದಲಾಯಿಸಲಿ?",
    "need.field_trade": "ಕೆಲಸದ ಬಗೆ",
    "need.field_detail": "ವಿವರ",
    "need.field_budget": "ನನ್ನ ಬಜೆಟ್",
    "need.searching": "{area} ಹತ್ತಿರ ಯಾರಾದರೂ ಇದ್ದಾರಾ ಎಂದು ಹುಡುಕುತ್ತಿದ್ದೇನೆ…",
    "need.found": "ಹತ್ತಿರದಲ್ಲಿ ಇವರು ಸಹಾಯ ಮಾಡಬಹುದು. ಮೂವರವರೆಗೆ ಆರಿಸಿ, ನಂತರ ಕೇಳಿ.",
    "need.nobody": "{km} ಕಿ.ಮೀ. ಒಳಗೆ ಇನ್ನೂ ಯಾರೂ ಇಲ್ಲ. ಇನ್ನಷ್ಟು ದೂರ ನೋಡಲೇ, ಅಥವಾ ಏನಾದರೂ ಬದಲಾಯಿಸುವಿರಾ?",
    "need.change": "ಏನಾದರೂ ಬದಲಾಯಿಸಿ",
    "need.asked": "ಕೇಳಿದೆ. ಅವರ ಏಜೆಂಟ್‌ಗಳು ನಿಮ್ಮ ಏಜೆಂಟ್ ಜೊತೆ ಮಾತಾಡುತ್ತವೆ — 'ನನ್ನ ಕೆಲಸಗಳು' ಪುಟದಲ್ಲಿ ನೋಡಿ.",
    "need.start_to": "{name} ಅವರಿಂದ ನಿಮಗೆ ಯಾವ ಕೆಲಸ ಆಗಬೇಕು? ನಿಮ್ಮ ಮಾತಿನಲ್ಲೇ ಹೇಳಿ.",
    "need.confirm_to": "{name} ಅವರನ್ನು ಕೇಳಲೇ?",
    "need.asking_to": "{name} ಅವರನ್ನು ಕೇಳುತ್ತಿದ್ದೇನೆ…",
    "need.composer": "ನಿಮಗೆ ಏನು ಬೇಕು ಹೇಳಿ",
    "need.placeholder": "ನಿಮಗೆ ಏನು ಬೇಕು ಬರೆಯಿರಿ…",
    "need.reading": "ನೀವು ಹೇಳಿದ್ದನ್ನು ಓದುತ್ತಿದ್ದೇನೆ…",
    "need.date_ok": "ಈ ದಿನಾಂಕ ಇರಲಿ",
};
//# sourceMappingURL=need.js.map